import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Form from '../common/Form'
import Input from '../common/Input'
import RadioGroup, { RadioButton } from '../common/RadioGroup'
import Button from '../common/Button'
import FormError from '../common/FormError'
import { Modal } from '../common/Ant'
import { required, isNumeric } from '../../utils/validators'
import { toTitleCase } from '../../utils/textFormatters'
import { POD_TYPES, SIZES } from '../../constants'

class GeneratePillarIDsForm extends Component {
  static propTypes = {
    submitAction: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      podType: PropTypes.string,
    }),
    error: PropTypes.string,
  }

  static defaultProps = {
    initialValues: { podType: POD_TYPES.SMART },
    error: undefined,
  }

  constructor(props) {
    super(props)

    this.state = {
      modalOpen: false,
      count: '',
      podType: props.initialValues.podType || POD_TYPES.SMART,
      fieldErrors: {},
      submitting: false,
    }
  }

  handleClose = () => {
    this.setState({ modalOpen: false, submitting: false, fieldErrors: {} })
  }

  handleOpen = () => {
    this.setState({
      modalOpen: true,
      count: '',
      podType: this.props.initialValues.podType || POD_TYPES.SMART,
      fieldErrors: {},
      submitting: false,
    })
  }

  validate = () => {
    const { count } = this.state
    const fieldErrors = {}
    const countError = [required(count), isNumeric(count)].find(Boolean)

    if (countError) {
      fieldErrors.count = countError
    }

    return fieldErrors
  }

  handleSubmit = event => {
    event.preventDefault()
    const fieldErrors = this.validate()

    if (Object.keys(fieldErrors).length) {
      this.setState({ fieldErrors })
      return
    }

    const { count, podType } = this.state
    const { submitForm } = this.props

    this.setState({ modalOpen: false, fieldErrors: {}, submitting: true })
    submitForm({ count, podType })
  }

  handleCountChange = event => {
    this.setState({ count: event.target.value })
  }

  handlePodTypeChange = event => {
    this.setState({ podType: event.target.value })
  }

  render() {
    const { error } = this.props
    const { modalOpen, count, podType, fieldErrors, submitting } = this.state

    return (
      <section className="GeneratePillarIDsForm">
        <Button
          onClick={this.handleOpen}
          text="Generate Pillar IDs"
          size={SIZES.SMALL}
        />
        <Modal
          title="Generate Pillar IDs"
          visible={modalOpen}
          footer={null}
          onCancel={this.handleClose}
          style={{ top: 16 }}
          destroyOnClose
        >
          <Form onSubmit={this.handleSubmit}>
            <Input
              label="Number of Pillar IDs Needed"
              className="w-100-ns mr3-ns"
              isRequired
              input={{
                name: 'count',
                value: count,
                onChange: this.handleCountChange,
                onBlur: () => {},
              }}
              meta={{
                error: fieldErrors.count,
                touched: Boolean(fieldErrors.count),
              }}
            />
            <RadioGroup
              size="medium"
              label="Smart Pod Type"
              input={{
                name: 'podType',
                value: podType,
                onChange: this.handlePodTypeChange,
              }}
            >
              <RadioButton value={POD_TYPES.SMART}>
                {toTitleCase(POD_TYPES.SMART)}
              </RadioButton>
              <RadioButton value={POD_TYPES.LEAK_POD}>Leak</RadioButton>
              <RadioButton value={POD_TYPES.EVAC_POD}>Evac</RadioButton>
            </RadioGroup>
            <FormError error={error} />
            <div className="flex justify-between">
              <Button invert text="Cancel" onClick={this.handleClose} />
              <Button text="Submit" type="submit" submitting={submitting} />
            </div>
          </Form>
        </Modal>
      </section>
    )
  }
}

const mapDispatchToProps = (dispatch, { submitAction }) => ({
  submitForm: payload => dispatch(submitAction.request(payload)),
})

export default connect(null, mapDispatchToProps)(GeneratePillarIDsForm)
